// Who may reach `/world`. Shared by the route gate and the library sidebar so
// the link and the page can never disagree about who gets in.

// Deep import so this gate does not pull the shared utilities barrel.
import { canAccess } from '@airhead-games/shared/utilities/gameAccess';
import type { UserAuthFields } from '@airhead-games/shared/types';

/** Tier the world sits behind until it is ready for a wider audience. */
const WORLD_ACCESS_TIER = 'poppy';

/**
 * The world is unreleased, so production keeps it to the poppy tier. Local
 * development is open — mirrors the backend, which skips catalog filtering
 * outside production so nobody has to log in as the admin to do their work.
 */
export const isWorldUnlocked = (user: UserAuthFields | null): boolean =>
  import.meta.env.DEV ||
  (user !== null && canAccess(user.accessTier, WORLD_ACCESS_TIER));
